import { useRef, useState } from 'react';
import { CategoryLocalTipsKey } from '../constants/storageKey';

export function useAutoCloseTips(props?: { timer?: number }) {
  const { timer = 3000 } = props || {};
  const [showTips, setShowTips] = useState(false);
  function closeTips() {
    setTimeout(() => {
      setShowTips(false);
    }, timer);
  }

  function openTips() {
    setShowTips(true);
    closeTips();
  }

  return { showTips, openTips };
}

export function useOnceTips() {
  const [showTips, setShowTips] = useState(false);
  // 已经展示过一次了
  const showTipsOnceRef = useRef(
    localStorage.getItem(CategoryLocalTipsKey) === '1',
  );

  function closeTips() {
    setShowTips(false);
    localStorage.setItem(CategoryLocalTipsKey, '1');
  }

  function openTips() {
    if (!showTipsOnceRef.current) {
      setShowTips(true);
    }
  }

  return { showTips, openTips, closeTips };
}
